import api from './api';

class AuthService {
  async login(credentials) {
    try {
      const response = await api.post('/auth/login', credentials);
      
      if (response.data.access_token) {
        this.setAuthData(response.data);
      }
      
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  setAuthData(data) {
    localStorage.setItem('access_token', data.access_token);
    localStorage.setItem('refresh_token', data.refresh_token);
    localStorage.setItem('user', JSON.stringify(data.user));
    localStorage.setItem('tenant_id', data.user.tenant_id);
  }

  async logout() {
    try {
      if (localStorage.getItem('access_token')) {
        await api.post('/auth/logout');
      }
    } finally {
      localStorage.removeItem('access_token');
      localStorage.removeItem('refresh_token');
      localStorage.removeItem('user');
      localStorage.removeItem('tenant_id');
      localStorage.removeItem('tenant_institution_config');
    }
  }

  getCurrentUser() {
    const user = localStorage.getItem('user');
    return user ? JSON.parse(user) : null;
  }

  isAuthenticated() {
    return !!localStorage.getItem('access_token');
  }

  hasPermission(permission) {
    const user = this.getCurrentUser();
    if (!user || !user.role) return false;
    
    return user.role.permissions?.some(p => p.name === permission) || false;
  }

  async updateProfile(userData) {
    const response = await api.put('/users/profile', userData);
    if (response.data) {
      const currentUser = this.getCurrentUser();
      const updatedUser = { ...currentUser, ...response.data };
      localStorage.setItem('user', JSON.stringify(updatedUser));
    }
    return response.data;
  }

  async changePassword(data) {
    return await api.post('/users/profile/change-password', data);
  }
}

export default new AuthService();
